import { useCallback, useState } from "react";

/**
 * "외부 페이지를 먼저 연 뒤에야 완료 표시를 할 수 있다" 규칙(전달서 §7·§8.2·§8.3).
 *
 * 외부 페이지에서 실제로 작업을 마쳤는지는 확인할 방법이 없다. 그래서 최소한
 * 링크를 한 번은 열게 만들어, 완료 버튼이 아무 맥락 없이 눌리는 것만 막는다.
 * 이동 자체는 `<a href>` 가 하고 이 훅은 "열었다"는 사실만 기록한다.
 * 세션 안에서만 의미가 있어 브라우저 저장소에 남기지 않는다.
 */
export default function useExternalLinkGate() {
  const [hasOpened, setHasOpened] = useState(false);

  const markOpened = useCallback(() => setHasOpened(true), []);

  // 선택지가 바뀌거나 모달을 닫았다 열면 열었다는 표시를 지운다.
  const reset = useCallback(() => setHasOpened(false), []);

  return { hasOpened, markOpened, reset };
}
